import React from "react";

const PrinterRoundedIcon = React.forwardRef(
  (
    {
      size = 34,
      variant = "primary",         
      withBg = true,
      rx = 8,
      bgColor,
      strokeColor,
      midFillColor,                
      tabFill = "#FFFFFF",       
      bottomFill = "#FFFFFF",     
      className,
      title,
      ...props
    },
    ref
  ) => {
    const isMuted = variant === "muted";

    const palette = {
      primary: {
        bg: "#5062F0",
        stroke: "#010311",
        mid: "#F2B90D",
        accent: "#010311",
      },
      muted: {
        bg: "#D0D3E2",
        stroke: "#9296AC",
        mid: "#FFFFFF",
        accent: "#9296AC",
      },
    }[isMuted ? "muted" : "primary"];

    const finalBg = bgColor ?? palette.bg;
    const finalStroke = strokeColor ?? palette.stroke;
    const finalMid = midFillColor ?? palette.mid;
    const finalAccent = finalStroke; 

    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={title ? undefined : true}
        role={title ? "img" : "presentation"}
        {...props}
      >
        {title ? <title>{title}</title> : null}

        {withBg && <rect width="34" height="34" rx={rx} fill={finalBg} />}

        <rect
          x="12.5"
          y="9.5"
          width="9"
          height="3.26667"
          rx="0.5"
          fill={tabFill}
          stroke={finalStroke}
        />

        <rect
          x="9.5"
          y="11.6338"
          width="15"
          height="7.53333"
          rx="1"
          fill={finalMid}
          stroke={finalStroke}
        />

        <rect
          x="12.5"
          y="16.9668"
          width="9"
          height="7.53333"
          rx="1"
          fill={bottomFill}
          stroke={finalStroke}
        />

        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 13.7999C20 13.5054 20.0799 13.2666 20.1786 13.2666H22.3214C22.4201 13.2666 22.5 13.5054 22.5 13.7999C22.5 14.0945 22.4201 14.3333 22.3214 14.3333H20.1786C20.0799 14.3333 20 14.0945 20 13.7999Z"
          fill={finalAccent}
        />
      </svg>
    );
  }
);

export default React.memo(PrinterRoundedIcon);
